import useSession from './useSession';

export default function useApplicationId(): string | undefined {
	const { lastApplicationId } = useSession();

	return lastApplicationId;
}
